<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <route-edit-form @on-submit="onRouteEditSubmit"></route-edit-form>
    </div>
  </div>
</template>
<script>
import RouteEditForm from "./RouteEditForm.vue";

export default {
  components: {
    RouteEditForm
  },
  data() {
    return {
      routeEditModel: {}
    };
  },
  methods: {
    onRouteEditSubmit(model) {
      this.routeEditModel = model;
      // this.$http.post(
      //   this.$apiBaseUrl + 'routes/' + this.routeEditModel.id, Object.assign(this.routeEditModel)
      // ).then(response => {
      // }, response => {
      // });
    }
  }
};
</script>
<style></style>
